import React from "react";
import { SourceSelector } from "@me8eon/source_selector-new";
import { useSelectedLlmModel } from "@me8eon/react_intent";

const LLM_MODEL_OPTIONS = [
    // GPT Models
    { id: "gpt-5", name: "GPT", description: "OpenAI GPT-5" },
    { id: "gpt-5-mini", name: "GPT Mini", description: "OpenAI GPT-5 Mini" },
    { id: "gpt-5-nano", name: "GPT Nano", description: "OpenAI GPT-5 Nano" },
    { id: "gpt-5.1", name: "GPT 5.1", description: "OpenAI GPT-5.1" },
    { id: "gpt-5.4", name: "GPT 5.4", description: "OpenAI GPT-5.4" },
    // Gemini Models
    { id: "gemini-2.5-flash", name: "Gemini Flash 2.5", description: "Google Gemini 2.5 Flash" },
    { id: "gemini-2.5-pro", name: "Gemini Pro 2.5", description: "Google Gemini 2.5 Pro" },
    { id: "gemini-3.5-flash", name: "Gemini Flash 3.5", description: "Google Gemini 3.5 Flash" },
    // Claude Models
    { id: "claude-4.5-sonnet", name: "Claude Sonnet 4.5", description: "Anthropic Claude 4.5 Sonnet" },
    { id: "claude-4.5-opus", name: "Claude Opus 4.5", description: "Anthropic Claude 4.5 Opus" },
    { id: "claude-4.6-sonnet", name: "Claude Sonnet 4.6", description: "Anthropic Claude 4.6 Sonnet" },
    { id: "claude-4.6-opus", name: "Claude Opus 4.6", description: "Anthropic Claude 4.6 Opus" },
    // Llama Models
    { id: "llama-3.3-70b-instruct-maas", name: "Llama 3.3 70B", description: "Meta Llama 3.3 70B Instruct" },
    // Mistral Models
    { id: "mistral-small-3.1", name: "Mistral Small 3.1", description: "Mistral AI Small 3.1" },
];

export const LlmModelSelectorPlugin: React.FC<{ isBottom?: boolean }> = ({ isBottom }) => {
    const [selectedModel, setSelectedModel] = useSelectedLlmModel();

    return (
        <SourceSelector
            sources={LLM_MODEL_OPTIONS}
            setSelectedSource={(id) => { if (id) setSelectedModel(id); }}
            selectedSource={selectedModel}
            top={!isBottom}
        />
    );
};
